import { GetterTree } from "vuex";
import { StoreState } from "@/store/type";
import { IDuplicateBookingsState } from "@/modules/DuplicateBookings/vuex/state";

const getters: GetterTree<IDuplicateBookingsState, StoreState> = {
  duplicateBookings: (state) => state.duplicateBookings,
  isFetchingDuplicateBookings: (state) => state.isLoading,
  duplicateBookingsError: (state) => state.error,
};

export default getters;
